module.exports = __webpack_public_path__ + "assets/sliders1.e283fd59.svg";